<template>
    <div class="person-page-wrapper">
        <Tabs class="content" :tabsConfig="tabsConfig" @tabClick="tabClick">
            <component :is="currentComponent" />
        </Tabs>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import AccountManage from "./components/account/AccountManage";
import GroupManage from "./components/group/GroupManage";
import RoleManage from "./components/role/RoleManage";
import OperationalLog from "./components/Ulog/OperationalLog";
import i18n from "@/i18n";

export default {
    name: "PersonManagePage",
    components: {
        Tabs,
        AccountManage,
        GroupManage,
        RoleManage,
        OperationalLog
    },
    data() {
        return {
            currentComponent: "AccountManage"
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: i18n.t("zhiji.personnel.accountTag"),
                    contentName: "AccountManage"
                },
                {
                    tabName: i18n.t("zhiji.personnel.roleTag"),
                    contentName: "RoleManage"
                },
                {
                    tabName: i18n.t("zhiji.personnel.groupTag"),
                    contentName: "GroupManage"
                },
                 {
                    tabName: i18n.t("zhiji.personnel.ulogTag"),
                    contentName: "OperationalLog"
                }
            ];
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponent = data.componentName;
        }
    }
};
</script>

<style lang="less" scoped>
.person-page-wrapper {
    min-height: 100%;
    padding: 0 0 16px 0;
    height: 100%;
    overflow-y: auto;
    background: #f2f7fb;
    box-sizing: border-box;
}
</style>
